import React from "react";
import { Typography } from "@mui/material";
import { Dialog, DialogContent, Stack, styled, Button } from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

const ButtonCancel = styled(Button)({
  backgroundColor: "rgb(138, 138, 138) !important",
  color: "white",
  textShadow: "1px 1px 2px rgb(161, 161, 161)",
  boxShadow: "0px 1px 2px rgb(161, 161, 161)",
});

function ResetDialog({ title, open, onClose, onClickYes }) {
  return (
    <Dialog title={title} open={open} onClose={onClose}>
      <DialogContent>
        <Stack gap={2} alignItems="center" justifyContent="center">
          <CancelOutlinedIcon sx={{ fontSize: "100px", color: "red" }} />
          <Typography variant="h6">Are you sure?</Typography>
          <Typography>Do you really want to Reset All Data?</Typography>

          <Stack
            width="100%"
            direction="row"
            justifyContent="space-evenly"
            spacing={5}
          >
            <ButtonCancel
              fullWidth
              variant="contained"
              size="small"
              onClick={onClose}
            >
              Cancel
            </ButtonCancel>
            <Button
              fullWidth
              variant="contained"
              size="small"
              sx={{ background: "#ff2c2c !important" }}
              onClick={onClickYes}
            >
              Delete
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default ResetDialog;
